import {
  Transaction,
  TransactionDirectionEnum,
  TransactionDto,
  TransactionListFilters,
  TransactionListFiltersDto,
  TransactionTypeDtoEnum,
} from '~models/Transaction';
import { isNotEmptyValue } from '@scansource-brazil/zeus-core-ui/data';
import { convertToBrCurrency } from '~/utils/textUtils';

export class TransactionAdapter {
  static toView(data: TransactionDto): Transaction {
    const transaction = new Transaction({});

    transaction._id = String(data.id);
    transaction.transactionDateTime = new Date(data.transactionDateTime);
    transaction.amount = convertToBrCurrency(data.value);
    transaction.value = data.value;
    transaction.type = TransactionTypeDtoEnum[
      data.type
    ] as unknown as Transaction['type'];
    transaction.transactionDirection = TransactionDirectionEnum[
      data.transactionDirection
    ] as unknown as Transaction['transactionDirection'];
    transaction.sign = data.sign;
    transaction.source = data.source;
    transaction.description = data.description;
    transaction.transactionIdentifier = data.transactionIdentifier;
    transaction.username = data.username;

    return new Transaction(transaction);
  }
}

export class TransactionListFilterAdapter {
  static toDto(
    data: TransactionListFilters,
    usePagination: boolean = true,
  ): TransactionListFiltersDto {
    const _filter = new TransactionListFiltersDto();
    if (!data.date?.length) {
      _filter.StartDate = new Date(new Date().setDate(new Date().getDate() - 5))
        .getTime()
        .toString();
      _filter.EndDate = new Date(Date.now()).getTime().toString();
    } else if (data.date.at(0)) {
      _filter.StartDate = data.date.at(0)?.getTime()?.toString() ?? '';
      _filter.EndDate = !data.date.at(1)
        ? (data.date.at(0)?.getTime()?.toString() ?? '')
        : (data.date.at(1)?.getTime()?.toString() ?? '');
    }

    if (data.transactionDirection !== undefined && data.transactionDirection !== null) {
      // Map numeric value to enum key
      const enumKey = Object.keys(TransactionDirectionEnum).find(
        key => TransactionDirectionEnum[key as keyof typeof TransactionDirectionEnum] === data.transactionDirection
      );
      if (enumKey) {
        _filter.type = enumKey;
      }
    }

    if (data.description) _filter.description = data.description;

    if (data.source) _filter.Source = data.source;

    if (data.transactionIdentifier)
      _filter.TransactionIdentifier = data.transactionIdentifier;

    if (usePagination) {
      if (data.currentPage) _filter.currentPage = data.currentPage;

      if (data.pageSize) _filter.pageSize = data.pageSize;
    } else {
      _filter.currentPage = undefined as any;
      _filter.pageSize = undefined as any;
    }

    return _filter;
  }
}
